export default __webpack_public_path__ + "static/media/step5_1.e2f4e43d.jpg";